import { render, staticRenderFns } from "./EventColorModal.vue?vue&type=template&id=73f76291&scoped=true"
import script from "./EventColorModal.vue?vue&type=script&lang=js"
export * from "./EventColorModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73f76291",
  null
  
)

export default component.exports